module.exports = __webpack_public_path__ + "static/media/256 bit encryption.f58693a0.svg";